import { shape } from "prop-types";

import {
  BIRTH_DATE_MAX,
  BIRTH_DATE_MIN,
} from "web/Pages/Checkout/Subscription/BenefitSummary/ActiveForm/constants";

import { DatepickerFormik } from "web/Layout/Datepicker";
import __ from "web/Layout/Translations";

import Checkbox from "web/Components/Common/Form/Checkbox";
import Field from "web/Components/Common/Form/Field";

import { peselMask } from "web/utils/peselMask";

const RequirePeselForm = ({ field, checkboxClass, classes }) => {
  return (
    <>
      <Checkbox
        uppercase
        name={`${field.id}.babyOrForeigner`}
        classes={checkboxClass}
      >
        <label
          htmlFor={`${field.id}.babyOrForeigner`}
          className={`${classes.label} ${classes.checkboxLabel}`}
        >
          {__("Obcokrajowiec / nowonarodzone dziecko")}
        </label>
      </Checkbox>
      <label htmlFor={`${field.id}.pesel`} className={classes.label}>
        {__("Pesel")}
      </label>
      <Field
        id={`${field.id}.pesel`}
        name={`${field.id}.pesel`}
        mask={peselMask}
      />
      <label htmlFor={`${field.id}.birthDate`} className={classes.label}>
        {__("Data urodzenia")}
      </label>
      <div className={`${classes.inputWrapper} ${classes.dataInputWrapper}`}>
        <DatepickerFormik
          name={`${field.id}.birthDate`}
          label={field.label}
          placeholder={__("Data urodzenia")}
          className={classes.input}
          minDate={BIRTH_DATE_MIN}
          maxDate={BIRTH_DATE_MAX}
          defaultValue={field.value}
        />
      </div>
    </>
  );
};

RequirePeselForm.propTypes = {
  classes: shape({}).isRequired,
  field: shape({}).isRequired,
  checkboxClass: shape({}).isRequired,
};

export default RequirePeselForm;
